import { CSSProperties, ImgHTMLAttributes } from "react";

interface PhoneFrameProps {
	className?: string;
	id?: string;
	style?: CSSProperties;
	/** The status bar (clock + battery). The small fanned-out and CTA phones leave it out. */
	statusBar?: boolean;
	img: ImgHTMLAttributes<HTMLImageElement> & { src: string };
}

/** The iPhone shell around an app screenshot. All the sizing lives in the stylesheet, per place the phone appears. */
export default function PhoneFrame({ className = "", id, style, statusBar = true, img }: PhoneFrameProps) {
	return (
		<div className={`iphone ${className}`.trim()} id={id} style={style}>
			<span className="island" aria-hidden="true" />
			{statusBar && (
				<span className="sbar" aria-hidden="true">
					<b>9:41</b>
					<i />
				</span>
			)}
			<img width={780} height={1688} alt="" {...img} />
		</div>
	);
}
